import { ChangeDetectionStrategy, Component, DestroyRef, inject, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Product, Simulation } from '@helpers/types/models';
import { BehaviorSubject } from 'rxjs';
import { UserService } from '../../../auth/user.service';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import { SimulationService } from '../simulation.service';
import { ProductsService } from '@helpers/repo/products.service';

@Component({
	selector: 'app-simulation-results',
	standalone: false,
	templateUrl: './simulation-results.component.html',
	styleUrl: './simulation-results.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimulationResultsComponent {
	task!: Simulation;

	readonly exporting$ = new BehaviorSubject<boolean>(false);
	private readonly destroyRef = inject(DestroyRef);

	constructor(
		private readonly dialogRef: DialogRef<boolean>,
		@Inject(DIALOG_DATA) readonly data: { task: Simulation, paging: Partial<any>, products: Product[] },
		protected readonly user: UserService,
		public readonly productsService: ProductsService,
		private readonly service: SimulationService
	) {
		this.task = this.data.task;
	}

	close(): void {
		this.dialogRef.close(false);
	}

	restart(): void {
		const param = {
			productId: this.task.productId,
			productName: this.task.productName,
			senderId: this.task.senderId,
			prefix: this.task.prefix,
		};
		this.service
			.create(param)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((resp) => {
				if (resp.createdId) {
					this.service.refresh$.next(true);
					this.dialogRef.close(true);
				}
			});
	}
}
